/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import styles from './ProtectedByRecaptcha.module.scss';

export function ProtectedByRecaptcha({
    className,
    ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cx('text-sm color-text-02 text-center', className)} {...rest}>
            This site is protected by reCAPTCHA. The Google{' '}
            <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
            >
                Privacy Policy
            </a>
            &nbsp;and&nbsp;
            <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
            >
                Terms of Service
            </a>{' '}
            apply.
        </div>
    );
}
